<template>
<div>
  <form :action="action" method="post" class="form">
    <input v-if="edit" type="hidden" name="_method" value="patch" />
    <input type="hidden" name="id" v-model="form.id">
    <input name="_token" type="hidden" :value="form.token">

    <div v-if="!isUserExist && !edit" class="form__row form__row--floating" :class="{'form__row--error': emailData.isFailure}">
      <input id="email" type="email" name="email" placeholder=" " v-model="form.email" @keydown.enter.prevent="checkEmail" @focus="resetToStep1" required>
      <label for="email">E-mail</label>
      <div class="form__row-help">{{ emailData.message }}</div>
    </div>

    <div v-if="!emailData.isSuccess && !edit" class="form__row form__row--without-label form__row--flex form__row--flex-end">
      <button v-if="!emailData.isPending" type="button" class="button" @click="checkEmail">Продолжить</button>
      <button v-else type="button" class="button" disabled>Отправка...</button>
    </div>

    <div v-if="emailData.isSuccess && !isUserExist" class="form__row form__row--floating">
      <input id="name" type="text" name="name" placeholder=" " v-model="form.name" required>
      <label for="name">Имя</label>
    </div>

    <div v-if="emailData.isSuccess && !isUserExist" class="form__row form__row--floating">
      <input id="phone" type="text" name="phone" placeholder=" " v-model="form.phone" required>
      <label for="phone">Телефон</label>
    </div>

    <div v-if="emailData.isSuccess && !isUserExist" class="form__row form__row--floating">
      <input id="password" type="password" name="password" placeholder=" " required>
      <label for="password">Пароль</label>
    </div>

    <div v-if="emailData.isSuccess && !isUserExist" class="form__row form__row--floating">
      <input id="password_confirm" type="password" name="password_confirm" placeholder=" " required>
      <label for="password_confirm">Повторите пароль</label>
    </div>

    <div class="form__row form__row--without-label" v-if="(isUserExist || edit) && form.email">
      <strong>E-mail</strong>
      <br>
      <small>{{ form.email }}</small>
    </div>

    <div class="form__row form__row--without-label" v-if="(isUserExist || edit) && form.name">
      <strong>Имя</strong>
      <br>
      <small>{{ form.name }}</small>
    </div>

    <div class="form__row form__row--without-label" v-if="(isUserExist || edit) && form.phone">
      <strong>Телефон</strong>
      <br>
      <small>{{ form.phone }}</small>
    </div>

    <div v-if="emailData.isSuccess || edit" class="form__row form__row--without-label">
      <table class="tbl tbl--mobile-is-table">
        <thead>
          <tr>
            <th>Индивидуальные права</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="rule in rules" :key="rule.id">
            <td>{{ rule.label }}</td>
            <td class="text-right">
              <input :id="`rule-${rule.id}`" :name="`rule[${rule.id}]`" type="checkbox" :checked="rule.isActive">
              <label :for="`rule-${rule.id}`"></label>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="emailData.isSuccess || edit" class="form__row form__row--without-label">
      <table class="tbl tbl--mobile-is-table">
        <thead>
          <tr>
            <th>Настройка уведомлений</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Получать уведомления о действиях сотрудника</td>
            <td class="text-right">
              <input id="notification" name="notification" type="checkbox" :checked="notification">
              <label for="notification"></label>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="emailData.isSuccess || edit" class="form__row form__row--without-label form__row--flex form__row--flex-end">
      <button v-if="isUserExist || edit" type="submit" class="button">Сохранить</button>
      <button v-else type="submit" class="button">Добавить</button>
      <button v-if="edit" form="delete-user" type="submit" class="button button--red" style="margin-left: 10px">Удалить сотрудника</button>
    </div>

  </form>

  <form v-if="edit" id="delete-user" :action="removeAction" method="post">
    <input type="hidden" name="_method" value="delete" />
    <input name="_token" type="hidden" :value="form.token">
  </form>

</div>
</template>

<script>
import api from "axios";

export default {
  props: {
    action: {
      type: String,
      required: true
    },
    removeAction: {
      type: String
    },
    edit: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      required: true
    },
    notification: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: null
    },
    email: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    phone: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      form: {
        token: "",
        id: this.id,
        email: this.email,
        name: this.name,
        phone: this.phone
      },
      emailData: {
        isPending: false,
        isFailure: false,
        isSuccess: false,
        message: ""
      },
      isUserExist: false
    };
  },

  methods: {
    checkEmail() {
      if (this.emailData.isPending || this.emailData.isSuccess) return;

      this.emailData.isPending = true;
      this.emailData.isFailure = false;
      this.emailData.isSuccess = false;
      this.emailData.message = "";

      api
        .post("/employees/checkEmail", {
          email: this.form.email
        })
        .then(response => {
          this.emailData.isPending = false;
          this.emailData.isFailure = false;
          this.emailData.isSuccess = true;
          this.emailData.message = "";

          if (response.data.isUserExist) {
            this.isUserExist = true;
            this.form.email = response.data.userData.email;
            this.form.name = response.data.userData.name;
            this.form.phone = response.data.userData.phone;
            this.form.id = response.data.userData.id;
          }
        })
        .catch(error => {
          this.emailData.isPending = false;
          this.emailData.isFailure = true;
          this.emailData.isSuccess = false;
          this.emailData.message = error.response.data.message;
        });
    },

    resetToStep1() {
      this.emailData.isPending = false;
      this.emailData.isFailure = false;
      this.emailData.isSuccess = false;
      this.emailData.message = "";
      this.isUserExist = false;
    }
  },

  created() {
    this.form.token = token;
  }
};
</script>
